// @core/api/endpoints/notifications/get_notification.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NotificationResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get notification by ID
 * Retrieves a specific notification by its unique identifier. Returns the full notification details including delivery status and metadata.
 */
export async function GetNotification(
  notification_id: string,
  options?: RequestOptions
): Promise<NotificationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/notifications/:notification_id`;
  requestPath = requestPath.replace(':notification_id', encodeURIComponent(notification_id));
  const requestOptions = options;
  return client.get<NotificationResponse>(requestPath, { ...requestOptions });
}
